var _rect, _text, _text2, _text3, _line, _text4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg404(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 300,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "#FFFFFF"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 150,
    fontFamily: "Montserrat, sans-serif",
    fontSize: 120,
    fill: "#1A1A1A"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "font-size",
    values: "120; 140; 120",
    dur: "2s",
    repeatCount: "indefinite"
  }), "\n    4\n")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 160,
    y: 150,
    fontFamily: "Montserrat, sans-serif",
    fontSize: 100,
    fill: "#E74C3C"
  }, "0")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 250,
    y: 150,
    fontFamily: "Montserrat, sans-serif",
    fontSize: 100,
    fill: "#1A1A1A"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "font-size",
    values: "120; 140; 120",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "1s"
  }), "\n    4\n")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 220,
    x2: 300,
    y2: 80,
    stroke: "#2ECC71",
    strokeWidth: 1
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 200,
    fontFamily: "Montserrat, sans-serif",
    fontSize: 10,
    fill: "#E74C3C"
  }, "no doe hoe? you know I say no")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.0dd61d81f3e2cd778c19b251b9249c0e.svg";
export { ForwardRef as ReactComponent };